module.exports = __webpack_public_path__ + "img/card-background.ceeb5527.png";